module.exports = __webpack_public_path__ + "img/liveplaceholder.66747bbe.jpg";